
import React from 'react';
import { ImageUpload } from '@/components/admin/ImageUpload';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuthSession } from '@/hooks/useAuthSession';
import { toast } from 'sonner';

const OgImageUploadPage = () => {
  const navigate = useNavigate();
  const { session, loading } = useAuthSession();
  
  // If user is not logged in and not loading, redirect to home page
  React.useEffect(() => {
    if (!loading && !session) {
      toast.error("Bitte melden Sie sich an, um diese Seite zu sehen.");
      navigate('/');
    }
  }, [session, loading, navigate]);
  
  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-xl">Laden...</div>
      </div>
    );
  }
  
  // If no session, show placeholder until redirect happens
  if (!session) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-xl">Nicht angemeldet. Weiterleitung...</div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-slate-100">
      <div className="container mx-auto py-12 px-4">
        <div className="max-w-2xl mx-auto">
          <Button 
            variant="outline" 
            className="mb-6"
            onClick={() => navigate('/')}
          >
            Zurück zur Hauptseite
          </Button>
          
          <h1 className="text-3xl font-bold mb-8">Bildverwaltung</h1>
          
          <div className="space-y-12">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-xl font-semibold mb-4">
                Bild für beliebige Sektion hochladen
              </h2>
              <p className="text-gray-600 mb-4">
                Hier kannst du ein Bild für eine beliebige Sektion der Website hochladen.
              </p>
              <ImageUpload />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-xl font-semibold mb-4">
                Bild für "Über Mich" (Hauptbild) hochladen
              </h2>
              <p className="text-gray-600 mb-4">
                Hier kannst du speziell das Hauptbild für die "Über Mich" Sektion hochladen.
              </p>
              <ImageUpload defaultSection="about-me-banner" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-xl font-semibold mb-4">
                Bild für "Predigt & Poetry" hochladen
              </h2>
              <p className="text-gray-600 mb-4">
                Hier kannst du das Bild für den "Predigt & Poetry" Bereich in der "Über Mich" Sektion hochladen.
              </p>
              <ImageUpload defaultSection="about-me-preaching" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-xl font-semibold mb-4">
                Bild für "Hobbies & Interessen" hochladen
              </h2>
              <p className="text-gray-600 mb-4">
                Hier kannst du das Bild für den "Hobbies & Interessen" Bereich in der "Über Mich" Sektion hochladen.
              </p>
              <ImageUpload defaultSection="about-me-passions" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-xl font-semibold mb-4">
                Social Media Vorschaubild (OG Image) hochladen
              </h2>
              <p className="text-gray-600 mb-4">
                Hier kannst du das Vorschaubild für Social Media Links hochladen (1200x630px empfohlen).
              </p>
              <ImageUpload defaultSection="meta-image" defaultSubsection="og-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OgImageUploadPage;
